// import PropTypes from 'prop-types';
// import { NavLink as RouterLink } from 'react-router-dom';
// // @mui
// import { Box, List, ListItemText } from '@mui/material';
// //
// import { StyledNavItem, StyledNavItemIcon } from './styles';

// // ----------------------------------------------------------------------

// NavSection.propTypes = {
//   data: PropTypes.array,
// };

// export default function NavSection({ data = [], ...other }) {
//   return (
//     <Box {...other}>
//       <List disablePadding sx={{ p: 1 }}>
//         {data.map((item) => (
//           <NavItem key={item.title} item={item} />
//         ))}
//       </List>
//     </Box>
//   );
// }

// // ----------------------------------------------------------------------

// NavItem.propTypes = {
//   item: PropTypes.object,
// };

// function NavItem({ item }) {
//   const { title, path, icon, info } = item;

//   return (
//     <StyledNavItem
//       component={RouterLink}
//       to={path}
//       sx={{
//         '&.active': {
//           color: 'text.primary',
//           bgcolor: 'action.selected',
//           fontWeight: 'fontWeightBold',
//         },
//       }}
//     >
//       <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

//       <ListItemText disableTypography primary={title} />

//       {info && info}
//     </StyledNavItem>
//   );
// }










// import PropTypes from 'prop-types';
// import { useState } from 'react';
// import { NavLink as RouterLink, useLocation } from 'react-router-dom';
// import { Box, List, ListItemText, Collapse } from '@mui/material';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import { StyledNavItem, StyledNavItemIcon } from './styles';

// NavSection.propTypes = {
//   data: PropTypes.array,
// };

// export default function NavSection({ data = [], ...other }) {
//   return (
//     <Box {...other}>
//       <List disablePadding sx={{ p: 1 }}>
//         {data.map((item) =>
//           item.children ? (
//             <NavItemDropdown key={item.title} item={item} />
//           ) : (
//             <NavItem key={item.title} item={item} />
//           )
//         )}
//       </List>
//     </Box>
//   );
// }

// // ── Single Item ─────────────────────────────────────────────────────────────
// NavItem.propTypes = { item: PropTypes.object };

// function NavItem({ item }) {
//   const { title, path, icon, info } = item;
//   return (
//     <StyledNavItem
//       component={RouterLink}
//       to={path}
//       sx={{
//         '&.active': {
//           color: 'text.primary',
//           bgcolor: 'action.selected',
//           fontWeight: 'fontWeightBold',
//         },
//       }}
//     >
//       <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
//       <ListItemText disableTypography primary={title} />
//       {info && info}
//     </StyledNavItem>
//   );
// }

// // ── Dropdown Item ───────────────────────────────────────────────────────────
// NavItemDropdown.propTypes = { item: PropTypes.object };

// function NavItemDropdown({ item }) {
//   const { title, icon, children } = item;
//   const { pathname } = useLocation();

//   const isAnyChildActive = children?.some((child) =>
//     pathname.startsWith(child.path)
//   );

//   const [open, setOpen] = useState(isAnyChildActive || false);

//   return (
//     <>
//       <StyledNavItem
//         onClick={() => setOpen((o) => !o)}
//         sx={{
//           cursor: 'pointer',
//           ...(isAnyChildActive && {
//             color: 'text.primary',
//             bgcolor: 'action.selected',
//             fontWeight: 'fontWeightBold',
//           }),
//         }}
//       >
//         <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
//         <ListItemText disableTypography primary={title} />
//         {open
//           ? <ExpandLess sx={{ fontSize: 18 }} />
//           : <ExpandMore sx={{ fontSize: 18 }} />
//         }
//       </StyledNavItem>

//       <Collapse in={open} timeout="auto" unmountOnExit>
//         <List disablePadding sx={{ pl: 2 }}>
//           {children.map((child) => (
//             <StyledNavItem
//               key={child.title}
//               component={RouterLink}
//               to={child.path}
//               sx={{
//                 height: 40,
//                 fontSize: 13,
//                 mb: 0.5,
//                 '&.active': {
//                   color: 'text.primary',
//                   bgcolor: 'action.selected',
//                   fontWeight: 'fontWeightBold',
//                 },
//               }}
//             >
//               <StyledNavItemIcon sx={{ width: 18, height: 18, mr: 1 }}>
//                 {child.icon && child.icon}
//               </StyledNavItemIcon>
//               <ListItemText disableTypography primary={child.title} />
//             </StyledNavItem>
//           ))}
//         </List>
//       </Collapse>
//     </>
//   );
// }














import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { Box, List, ListItemText, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { StyledNavItem, StyledNavItemIcon } from './styles';

NavSection.propTypes = { data: PropTypes.array };

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) =>
          item.children ? (
            <NavItemDropdown key={item.title} item={item} />
          ) : (
            <NavItem key={item.title} item={item} />
          )
        )}
      </List>
    </Box>
  );
}

// ── Single Item ──────────────────────────────────────────────────────────────
NavItem.propTypes = { item: PropTypes.object };

function NavItem({ item }) {
  const { title, path, icon, info } = item;
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        mb: 0.5,
        '&.active': {
          // color: '#103996',
          // bgcolor: 'rgba(16, 57, 150, 0.08)',
          color: 'white',
          bgcolor: '#103996',
          fontWeight: 'fontWeightBold',
          '& svg': { color: 'white' },
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}

// ── Dropdown Item ────────────────────────────────────────────────────────────
NavItemDropdown.propTypes = { item: PropTypes.object };

function NavItemDropdown({ item }) {
  const { title, icon, children } = item;
  const { pathname } = useLocation();

  const isAnyChildActive = children?.some((child) =>
    pathname.startsWith(child.path)
  );

  const [open, setOpen] = useState(isAnyChildActive || false);

  return (
    <Box sx={{ mb: 1 }}>
      <StyledNavItem
        onClick={() => setOpen((o) => !o)}
        sx={{
          cursor: 'pointer',
          mb: 0.5,
          ...(isAnyChildActive && {
            color: 'white',
            bgcolor: '#103996',
            fontWeight: 'fontWeightBold',
            '& svg': { color: 'white' },
          }),
        }}
      >
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
        <ListItemText disableTypography primary={title} />
        {open
          ? <ExpandLess sx={{ fontSize: 18, color: 'text.secondary' }} />
          : <ExpandMore sx={{ fontSize: 18, color: 'text.secondary' }} />
        }
      </StyledNavItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding sx={{ pl: 2, mt: 0.5, mb: 0.5 }}>
          {children.map((child) => (
            <StyledNavItem
              key={child.title}
              component={RouterLink}
              to={child.path}
              sx={{
                height: 40,
                fontSize: 13,
                mb: 0.5,
                '&.active': {
                  color: '#103996',
                  bgcolor: 'rgba(16, 57, 150, 0.08)',
                  fontWeight: 'fontWeightBold',
                  '& svg': { color: '#103996' },
                },
              }}
            >
              <StyledNavItemIcon sx={{ width: 18, height: 18, mr: 1 }}>
                {child.icon && child.icon}
              </StyledNavItemIcon>
              <ListItemText disableTypography primary={child.title} />
            </StyledNavItem>
          ))}
        </List>
      </Collapse>
    </Box>
  );
}